import request from "../request";

/**
 * Описание ответа сервера после применения промокода
 * @typedef {Object} PromoApplyResponse
 * @property {boolean} status
 * @property {number} commission
 * @property {number} summ
 * @property {number} discount
 * @property {number} bonuses
 * @property {Array} carts
 * @property {Object.<string, import("../types/cart").ActiveCartsEvent>} active_carts
 */

/**
 * Применяет промокод
 * @param {Object} params
 * @param {number} params.orderId
 * @param {string} params.code
 * @return {Promise<PromoApplyResponse>}
 */
export const apply = ({ orderId, code }) => {
  return request({
    url: "/promo/apply",
    data: {
      order_id: orderId,
      code,
    },
  });
};
